module.exports = __webpack_public_path__ + "img/Attack_Elektricshock.f5887f88.png";